import { NgModule } from '@angular/core';

import { ConsultantOverviewContainerComponent } from './consultant-overview.container';

export const COMPONENTS = [
  ConsultantOverviewContainerComponent
];

@NgModule({
  declarations: COMPONENTS,
  imports: [],
  exports: COMPONENTS,
  providers: [],
  bootstrap: [],
})
export class ConsultantOverviewModule {
}
